import styled from 'styled-components';
import { Badges as TCBadges } from '@gv/triage-components';

export const Badges = styled(TCBadges)`
  margin-top: 8px;
  margin-bottom: 4px;
`;
